import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/system';

const theme = createTheme();

export default makeStyles (({
    ul: {
        justifyContent: "space-between",
    },

}))